import type { ConceptDef } from '../types';

export const echoicWords: ConceptDef = {
  kind: 'supervisorScored',
  id: 'echoic-words',
  label: 'Echoic Words',
  category: 'Echoic',
  description: 'Speak a word; learner repeats it. Supervisor scores.',
  config: {
    promptMode: 'AUDIO',
    prompts: [
      { prompt: 'dog' },
      { prompt: 'mom' },
      { prompt: 'ball' },
      { prompt: 'milk' },
      { prompt: 'cup' },
      { prompt: 'cookie' },
      { prompt: 'shoe' },
      { prompt: 'water' },
    ],
  },
};
